import React from "react";
import { Link } from "react-router-dom";

/**
 * Compact newsletter prompt shown in the footer. Links to the dedicated
 * newsletter signup page (`/newsletter`), where the email is captured and
 * submitted to MailerLite via the backend.
 */
export default function NewsletterSignup() {
    return (
        <div className="landing-footer-newsletter">
            <h4 className="landing-footer-newsletter-heading">Get The Polaris Athlete Hub Newsletter</h4>
            <p className="landing-footer-newsletter-desc">
                Insights and resources for success in today&apos;s student-athlete landscape.
            </p>
            <Link className="landing-footer-newsletter-link" to="/newsletter">
                Sign up <span aria-hidden="true">→</span>
            </Link>
        </div>
    );
}
